import React, {Component} from 'react';
import { Field ,FieldArray,change } from 'redux-form'
import {locale} from "../locale/AppLocale";
import DropZone from '../Components/DropZone'
import {DropDown,DropDownItem,DropDownHeading} from '../Components/DropDown'

const renderPlainField = ({ input, placeholder, type, meta: { touched, error } }) => (
    <div className={`input-c input-c--plain ` + (touched && error ?`has-error`:``)}>
        <input {...input} placeholder={placeholder} className="input" type={type}/>
    </div>
);

const tdStyle = {
    verticalAlign:"top"
};

const renderVariantField = ({fields,dispatch,variants}) => {
    return (
        <div className="variants--table-wrapper ">

            { fields.length  > 0 &&
            <table className="table default variants--table">
                <thead>
                <tr>
                    <th width="1"></th>
                    <th width="10%"></th>
                    <th width='10%'>السعر</th>
                    <th width='10%'>السعر القديم</th>
                    <th width='10%'>الوحدة</th>
                    <th width='10%'>بار كود</th>
                    <th width='10%'>الكمية</th>
                    <th>صور المنتج</th>
                </tr>
                </thead>
                <tbody className="table--body">
                { fields.map((fieldName, key) => {
                    let product = fields.get(key)
                    return (
                        <tr className="drow" key={fieldName}>
                            <td style={tdStyle}>
                                <Field
                                    component={renderPlainField}
                                    name={ fieldName + `.is_active`}
                                    className="plain input-checkbox"
                                    type="checkbox" />
                            </td>

                            <td style={tdStyle} className="title">
                                { product.items.map(function (variant, i) {
                                    return <span key={i}
                                                 className={`color-variant color-variant_` + (i + 1)}>{variant.name}</span>
                                })}
                            </td>

                            <td style={tdStyle}>
                                <div className="input-c">
                                    <Field
                                        component={renderPlainField}
                                        name={ fieldName + `.price`}
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        className="input-price input form-control auto-height input-xs"/>
                                    <button type="button"  className="btn-1 btn--block btn--small" onClick={() =>{
                                        fields.forEach((fieldName) => {
                                            dispatch(change('productForm', fieldName + `.price`,product.price));
                                        })
                                    }}>{locale.get('apply_all')}</button>
                                </div>
                            </td>
                            <td style={tdStyle}>
                                <div className="input-c">
                                    <Field
                                        component={renderPlainField}
                                        name={ fieldName + `.old_price`}
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        className="input-price input form-control auto-height input-xs"/>
                                    <button type="button"  className="btn-1 btn--block btn--small" onClick={() =>{
                                        fields.forEach((fieldName) => {
                                            dispatch(change('productForm', fieldName + `.old_price`,product.old_price));
                                        })
                                    }}>{locale.get('apply_all')}</button>
                                </div>
                            </td>

                            <td style={tdStyle}>
                                <div className="input-c">
                                    <Field
                                        component={renderPlainField}
                                        name={ fieldName + `.sku`}
                                        type="text"
                                        className="input form-control auto-height input-xs"/>
                                    <button type="button" className="btn-1 btn--block btn--small" onClick={() =>{
                                        fields.forEach((fieldName) => {
                                            dispatch(change('productForm', fieldName + `.sku`,product.sku));
                                        })
                                    }}>{locale.get('apply_all')}</button>
                                </div>
                            </td>

                            <td style={tdStyle}>
                                <div className="input-c">
                                    <Field
                                        component={renderPlainField}
                                        name={ fieldName + `.barcode`}
                                        type="text"
                                        className="input form-control auto-height input-xs"/>
                                </div>
                            </td>

                            <td style={tdStyle}>
                                <div className="input-c">
                                    <Field
                                        component={renderPlainField}
                                        name={ fieldName + `.quantity`}

                                        type="text" className="input form-control auto-height input-xs"/>

                                    <button type="button" className="btn-1 btn--block btn--small"
                                            onClick={() =>{
                                                fields.forEach((fieldName) => {
                                                    dispatch(change('productForm', fieldName + `.quantity`,product.quantity));
                                                })
                                            }}>{locale.get('apply_all')}</button>

                                </div>
                            </td>

                            <td>
                                <FieldArray
                                    component={DropZone}
                                    disabled={false}
                                    name={ fieldName + `.images`}
                                    name2={ fieldName + `.images`}/>


                                {
                                    product.images &&
                                    product.images.length > 0 &&
                                    <DropDown title={locale.get('apply_images')}>
                                        <DropDownItem
                                            key={+ fieldName + '_all' }
                                            className="btn-1 btn--small"
                                            type="button"
                                            title={locale.get('apply_to_all')}
                                            onClick={() => {
                                                fields.forEach((fieldName,index) => {
                                                    dispatch(change('productForm', fieldName + `.images`,product.images));
                                                })
                                            }}/>
                                        {Object.keys(variants).map(variant => (
                                            <div key={fieldName + variant}>
                                                <DropDownHeading title={variant}/>
                                                {
                                                    variants[variant].map(item => (
                                                        <DropDownItem
                                                            key={item.value + '' + fieldName + variant }
                                                            className="btn-1 btn--small"
                                                            type="button"
                                                            title={item.label}
                                                            onClick={() => {
                                                                fields.forEach((fieldName,index) => {
                                                                    const apply = fields.get(index).items.some((variantItem) => (
                                                                        variantItem.id === item.value && item.attribute_id === variantItem.attribute_id
                                                                    ));
                                                                    if(apply){
                                                                        dispatch(change('productForm', fieldName + `.images`,product.images));
                                                                    }
                                                                })
                                                            }}/>
                                                    ))
                                                }
                                            </div>
                                        ))
                                        }
                                    </DropDown>}
                            </td>

                        </tr>
                    )
                })}
                </tbody>
            </table>}
        </div>

    );
};

export default class ProductVariants extends Component {
    render() {
        return (

        <FieldArray
            variants={this.props.variants}
            name="variants"
            dispatch={this.props.dispatch}
            component={renderVariantField}/>
        )
    }
}
